import { Component, type ReactNode } from "react";
import { hardReload } from "@/lib/lazyWithReload";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Catches failures to load parts of the site (usually an outdated cached
 * version after a publish) and offers a reload instead of a blank screen.
 */
class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background p-6 text-center">
        <p className="text-foreground text-lg font-medium">
          Има нова версия на сайта.
        </p>
        <p className="text-muted-foreground text-sm">A new version of the site is available.</p>
        <button
          type="button"
          onClick={() => void hardReload()}
          className="rounded-md bg-primary px-6 py-3 text-primary-foreground font-medium"
        >
          Презареди / Reload
        </button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
